import { App } from 'vue';
import TourStep from '../tour/src/tour-step.vue';

TourStep.install = (app: App): void => {
    app.component(TourStep.name, TourStep);
};

export default TourStep;

declare module 'vue' {
  export interface GlobalComponents {
      PtTourStep: typeof TourStep;
  }
}
